import CompactTimezoneList from 'compact-timezone-list'

function offsetToNum(offset) {
  let results = offset.match(/^([+-])(\d+):(\d+)$/);
  let num = results[2] * 60 + results[3];

  switch (results[1]) {
    case '+':
      return num;
    case '-':
      return 0 - num;
    default:
      return 0;
  }
}

let list = CompactTimezoneList.
  map( function(obj, idx) {
    return {
      id: (idx + 1),
      offset: obj.offset,
      label:  obj.label,
      tzCode: obj.tzCode,
      timeNum: offsetToNum(obj.offset),

      get: function() {
        return `(GTM${obj.offset}) ${obj.tzCode}`;
      },
    };
  }).
  sort( function(a, b) {
    if (a.timeNum == b.timeNum) {
      if (a.tzCode > b.tzCode) {
        return 1;
      } else if(a.tzCode < b.tzCode) {
        return -1;
      } else {
        return 0;
      }
    } else {
      return a.timeNum - b.timeNum;
    }
  });

export default list;
